import Link from 'next/link'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'

interface FooterProps {
  description: string
  ctaText: string
  ctaLink: string
  trackingEvent?: { clickText: string; clickUrl: string; location: string; type: string }
}

export const Footer = ({ ctaLink, ctaText, description, trackingEvent }: FooterProps) => {
  return (
    <div className='border-border-default border-t pt-8  lg:flex lg:text-left'>
      <p className='xxl:text-lg 2xxl:text-xl text-text-alternative mb-0 lg:mr-2'>{description}</p>
      <Link href={ctaLink} legacyBehavior passHref>
        <a
          className='xxl:text-lg 2xxl:text-xl'
          onClick={() => trackingEvent && trackClickForSegmentAnalytics(trackingEvent)}
        >
          {ctaText}
        </a>
      </Link>
    </div>
  )
}
